import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommunicationButtonComponent } from '../email-content/communication-button/communication-button.component';
import { EnvelopeButtonComponent } from '../email-content/envelope-button/envelope-button.component';



@NgModule({
  declarations: [CommunicationButtonComponent, EnvelopeButtonComponent],
  exports: [CommunicationButtonComponent, EnvelopeButtonComponent],
  imports: [
    CommonModule
  ]
})
export class SharedModule { }
